import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ 
  title = "Best Private University in Dehradun, Uttarakhand", 
  description = "Maya Devi Campus, one of the best universities in Dehradun, offers quality education with modern facilities and experienced faculty. Join us for a bright future in academics at a top private university in Uttarakhand, known for its commitment to higher education and academic excellence.",
  keywords = " Best University in Dehradun,Best University in Uttarakhand, Best Private University in Uttarakhand,Best Private University in Dehradun, Best College In Dehradun , Best Private College in Dehradun , Top college in Dehradun, best placement university in Uttarakhand, Best placement university in Dehradun"
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <link rel="canonical" href="https://maya.edu.in" />
    </Helmet>
  );
};

export default SEO; 